module.exports = __webpack_public_path__ + "static/media/ic_hs_cover_periods.3999b268.svg";